import React from "react";

export default function VastuCompassPlaceholder() {
  return (
    <div
      className="relative flex h-64 w-full items-center justify-center overflow-hidden rounded-xl border border-dashed border-slate-300 bg-white"
      role="img"
      aria-label="Animated vastu compass placeholder"
    >
      <svg
        viewBox="0 0 200 200"
        className="h-44 w-44 text-amber-500"
        aria-hidden="true"
      >
        <circle cx="100" cy="100" r="88" fill="none" stroke="#E2E8F0" strokeWidth="4" />
        <circle cx="100" cy="100" r="60" fill="none" stroke="#CBD5F5" strokeWidth="2" />
        <line x1="100" y1="18" x2="100" y2="182" stroke="#E2E8F0" strokeWidth="2" />
        <line x1="18" y1="100" x2="182" y2="100" stroke="#E2E8F0" strokeWidth="2" />
        <polygon
          points="100,36 108,100 100,164 92,100"
          fill="#F59E0B"
          className="origin-center animate-[spin_12s_linear_infinite]"
        />
        <circle cx="100" cy="100" r="6" fill="#0F172A" />
      </svg>
      <div className="absolute inset-0 animate-pulse bg-amber-100/30" />
      {/* Visual placeholder only. Replace with real analysis output later. */}
    </div>
  );
}
